import React from 'react';

import { TMediaItem } from '../../../../../types/TBatchGallery';

import {
  StyledCheckbox,
  StyledMediaWrapper,
  StyledCreationDate,
  StyledInfoAndActionsWrapper,
  StyledImage,
  StyledVideo,
} from './media-item-styles';

const MediaItem = ({
  item,
  selected,
  setSelected,
  creationDate,
  lockedCheckboxes,
  batchStatus,
}: TMediaItem) => {
  const [checked, setChecked] = React.useState(false);

  const handleSetSelected = (itemTarget: any) => {
    if (!checked) {
      setSelected((prevState: any) => [...prevState, itemTarget]);
      return;
    }

    if (checked) {
      setSelected((prevState: any) => prevState.filter((media: any) => media !== itemTarget));
    }
  };

  React.useEffect(() => {
    const checkItemHasInSelecteds = Boolean(
      selected.find((itemSelected: any) => itemSelected === item.id),
    );

    if (checkItemHasInSelecteds) {
      setChecked(true);
      return;
    }

    if (!checkItemHasInSelecteds) {
      setChecked(false);
    }
  }, [selected, item]);

  return (
    <li key={item.id}>
      <StyledMediaWrapper>
        <>
          {item.mediaFormat === 'VIDEO' && (
          <StyledVideo
            deleted={item.status !== 'PUBLISHED'}
          >
            <source src={item.sourceUrl} type="video/mp4" />
            <source src={item.sourceUrl} type="video/ogg" />
            Your browser does not support HTML video
          </StyledVideo>
          )}

          {item.mediaFormat === 'PHOTO' && (
            <>
              <StyledImage
                src={item.sourceUrl}
                deleted={item.status !== 'PUBLISHED'}
              />
            </>
          )}
        </>

        <StyledInfoAndActionsWrapper>
          {
            item.status === 'PUBLISHED' &&
            batchStatus !== 'PENDING' &&
            batchStatus !== 'PROCESSING' && (
              <StyledCheckbox
                checked={checked}
                disabled={lockedCheckboxes}
                onChange={() => handleSetSelected(item.id)}
              />
            )
          }

          <StyledCreationDate>
            Data de Criação:
            <br />
            {creationDate}
          </StyledCreationDate>
        </StyledInfoAndActionsWrapper>

      </StyledMediaWrapper>
    </li>
  );
};
export { MediaItem };
